import React, {useState} from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import logopadelbox from "../../assets/images/padelbox_logo_quadrado_white.svg";

// React Components
import RegistrationForm from "./RegistrationForm";
import LoginForm from "./LoginForm";
import PasswordRecoveryForm from "./PasswordRecoveryForm";

// CSS Files
import './styles.css';

const Login = (props) => {
   const [page, setPage] = useState("login");

   return (
      <div className={"Login"}>
         <Container>
            <Row className={"image-container"}>
               <Col xs={6} sm={5} md={4} lg={3} className={"mx-auto"}>
                  <img className={"img-fluid w-100"} src={logopadelbox}/>
               </Col>
            </Row>

            {page === "login" &&
               <LoginForm setPage={setPage} location={props.location}/>
            }

            {page === "registration" &&
               <RegistrationForm setPage={setPage}/>
            }

            {page === "passwordRecovery" &&
               <PasswordRecoveryForm setPage={setPage}/>
            }
         </Container>
      </div>
   );
};

export default Login;
